import { authServiceApi } from "../../apis/authService.api";
import { AUTH_API_TAGS } from "../../app.constants";
import type {
  IAuthResponse,
  IGenericResponse,
  ILogoutDto,
  IRefreshDto,
  IRegisterDto,
  IRequestOtpDto,
  IUploadResponse,
  IVerifyOtpDto,
} from "./auth.types";

// TODO: LOGIN Phone: 01741223556

export const authApiEndpoint = authServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    register: builder.mutation<IGenericResponse, IRegisterDto>({
      query: (body) => ({
        url: "/auth/register",
        method: "POST",
        body,
      }),
    }),

    requestOtp: builder.mutation<IGenericResponse, IRequestOtpDto>({
      query: (body) => ({
        url: "/auth/otp/request",
        method: "POST",
        body,
      }),
    }),

    verifyOtp: builder.mutation<IAuthResponse, IVerifyOtpDto>({
      query: (body) => ({
        url: "/auth/otp/verify",
        method: "POST",
        body,
      }),
      invalidatesTags: [AUTH_API_TAGS.AUTH],
    }),

    refreshToken: builder.mutation<IAuthResponse, IRefreshDto>({
      query: (body) => ({
        url: "/auth/refresh",
        method: "POST",
        body,
      }),
    }),

    logout: builder.mutation<IGenericResponse, ILogoutDto>({
      query: (body) => ({
        url: "/auth/logout",
        method: "POST",
        body,
      }),
    }),

    uploadFile: builder.mutation<IUploadResponse, FormData>({
      query: (body) => ({
        url: "https://hrx-api.retail-x.org/api/v1/data-dump/upload-File",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useRegisterMutation,
  useRequestOtpMutation,
  useVerifyOtpMutation,
  useRefreshTokenMutation,
  useLogoutMutation,
  useUploadFileMutation,
} = authApiEndpoint;
